<template lang="pug">
  .syncEdit.mb-5
    .content(v-if="sync")
        .nav-content.clearfix.d-flex.justify-content-center
          div.mx-5.custom-nav(v-for="(tab, index) in tabList" v-bind:key="tab.code")
            .clickable(v-if="isEdit" @click="goTo(index)")
              span.circle.d-flex.align-items-center.m-auto(:class="(currentVisible.code==tab.code || stepsCompleted >= index) ? 'current-active':''")
                span.text-center.m-auto {{index + 1}}
              span.circle-text(:class="(currentVisible.code==tab.code || stepsCompleted >= index) ? 'current-active':''") {{tab.title}}
            .unclickable(v-if="!isEdit")
              span.circle.d-flex.align-items-center.m-auto(:class="(currentVisible.code==tab.code || stepsCompleted >= index) ? 'current-active':''")
                span.text-center.m-auto {{index + 1}}
              span.circle-text(:class="(currentVisible.code==tab.code || stepsCompleted >= index) ? 'current-active':''") {{tab.title}}
          //- ul.nav.nav-tabs
          //-     li.nav-item(v-for="tab in tabList" v-bind:key="tab.code")
          //-         a.nav-link(href='#' v-on:click="currentVisible=tab.code" :class="(currentVisible==tab.code) ? 'active':''") {{tab.title}}

        hr 
        .tab-containers.pt-4.mt-4
          //- Name - syncName, simple input text
          .syncNameContainer(v-if="currentVisible.code=='name'" :class="(isLoading) ? 'loadingClass' : ''" )
            .title.mt-4 Name
            input.mt-4(type="text" v-model="sync.name")
          
          //- 
          .syncFromSettingsContainer(v-if="currentVisible.code=='sourceSettings'" :class="(isLoading) ? 'loadingClass' : ''" )
            //- .title.mt-4 From settings
            .row
              .col-md-5.col-12
                .filters.mt-4(v-if="sync.sourceSettings.filters.length > 0")
                  .title Filters
                  .filter.mt-3(v-for="filter in sync.sourceSettings.filters" v-bind:key="filter.code")
                    InputComponent(v-bind:inputObject="filter" :ref="filter.code")
                .settings.mt-4(v-if="sync.sourceSettings.settings.length > 0")
                  .title Settings
                  .setting.mt-3(v-for="setting in sync.sourceSettings.settings" v-bind:key="setting.code")
                    InputComponent(v-bind:inputObject="setting" :ref="setting.code")
              .col-md-1.xs-hidden
              .col-md-5.col-12
                .feedInfo(v-if="sync.source.showFeedInfo").mt-4
                  .title File info
                  FeedInfoComponent(:feedInfo="sync.feedInfoSettings" ref="source_feed_info").mt-3

          .syncColSetupContainer(v-if="currentVisible.code=='userMappings'" :class="(isLoading) ? 'loadingClass' : '' ")
            //- .title.mt-4 Column Setup
            ColumnMappingsComponent(:columnMappings="sync.columnsMappings", :userMappings="sync.userMappings", :syncDirection="sync.direction" ref="user_mappings").mt-3

          .syncToSettingsContainer(v-if="currentVisible.code=='destinationSettings'" :class="(isLoading) ? 'loadingClass' : '' ")
            //- .title.mt-4 To settings
            .row
              .col-6
                .filters.mt-4(v-if="sync.destinationSettings.filters.length > 0")
                  .title Filters
                  .filter.mt-3(v-for="filter in sync.destinationSettings.filters" v-bind:key="filter.code")
                    InputComponent(v-bind:inputObject="filter" :ref="filter.code")
                .settings.mt-4(v-if="sync.destinationSettings.settings.length > 0")
                  .title Settings
                  .setting.mt-3(v-for="setting in sync.destinationSettings.settings" v-bind:key="setting.code")
                    InputComponent(v-bind:inputObject="setting" :ref="setting.code")
              
              .col-6
                .feedInfo(v-if="sync.destination.showFeedInfo").mt-4
                  .title File info
                  FeedInfoComponent(:feedInfo="sync.feedInfoSettings", ref="destination_feed_info").mt-3
          .syncScheduleLaunchContainer(v-if="currentVisible.code=='scheduleLaunch'", :class="(isLoading) ? 'loadingClass' : '' ")
            .title.mt-4 Schedule and Launch
            SchedulingSettings(:settings="sync.scheduling.settings")
        
        button(@click="prev()" v-if="canGoPrev").custom-btn.prev.float-left.mt-4 Previous
        button(@click="next()" v-if="canGoNext && !isLoading").custom-btn.next.float-right.mt-4.px-4 Next &gt;
        button(@click="next()" v-if="isLoading").custom-btn.next.float-right.mt-4.px-4 Loading...
        button(@click="save()" v-if="!canGoNext").custom-btn.next.float-right.mt-4.px-4 Save
        button(@click="save()" v-if="isEdit && canGoNext").custom-btn.blue.float-right.mt-4.mx-3.px-4 Save
</template>

<script>
import {InputComponent, FeedInfoComponent, ColumnMappingsComponent, SchedulingSettings} from './'
import {Validation, APIManager} from './../../../helpers'
import VALIDATE_SYNC from '../../../graphql/ValidateSync.gql'
export default {
  name: 'SyncEdit',
  props:{
    sync: Object,
    isEdit: Boolean,
    openOnTab: Number
  },
  components: {
    InputComponent,
    FeedInfoComponent,
    ColumnMappingsComponent,
    SchedulingSettings
  },
  data() {
    return {
      isLoading: false,
      apollo: null,
      currentVisible: {
        code: 'name',
        index: 0,
      },
      stepsCompleted: 0,
      productsList: [],
      tabList: [
        {
          code: "name",
          title: "Name your sync",
        },
        {
          code: "sourceSettings",
          title: "Source settings",
        },
        {
          code: "userMappings",
          title: "Column setup"
        },
        {
          code: "destinationSettings",
          title: "Destination settings"
        },
        {
          code: "scheduleLaunch",
          title: "Schedule and Launch"
        }
      ]
    }
  },
  mounted() {
    if(this.openOnTab){
      this.goTo(this.openOnTab)
    }
  },
  methods: {
    async next(){
      this.isLoading = true;
      if(await this.validate()){
        this.currentVisible = {
            index: this.currentVisible.index + 1,
            code: this.tabList[this.currentVisible.index + 1].code,
        }
        this.stepsCompleted++;
      }
      this.isLoading = false;
    }, 
    prev(){
      this.currentVisible = {
          index: this.currentVisible.index - 1,
          code: this.tabList[this.currentVisible.index - 1].code,
      }
      this.stepsCompleted--;
    },
    goTo(index){
      this.currentVisible = {
          index: index,
          code: this.tabList[index].code,
      }
      this.stepsCompleted = index;
    },
    async save(){
      this.isLoading = true;
      if(await this.validate()){
        this.$emit('submit-data')
      }
      this.isLoading = false;
    },
    async validate(){
      const requiredValidate = Validation.validateFromRefs(this.$refs)
      if(requiredValidate){
        const syncToSave = APIManager.prepareSyncForSaving(this.sync)
        
        try {
          const validateMutation = await this.$apollo.mutate({
            // Query
            mutation: VALIDATE_SYNC,
            // Parameters
            variables: {
              input: {
                node: this.currentVisible.code,
                syncInput: syncToSave
              },
            }
          })
          
          if(validateMutation){
            console.log(validateMutation.data.smartsyncValidateField)
            if(!validateMutation.data.smartsyncValidateField.isValid) {
              const newSyncObject = JSON.parse(validateMutation.data.smartsyncValidateField.sync);
              this.sync[this.currentVisible.code] = newSyncObject[this.currentVisible.code];
              const genericErrors = validateMutation.data.smartsyncValidateField.genericErrors;
              if(genericErrors.length > 0){
                genericErrors.forEach(genericError => {
                  this.$toasted.show(genericError, {
                    type: "error",
                    duration: 10000,
                    className: "customAlert",
                    containerClass: "customAlertContainer",
                    action : {
                      text : 'Close',
                      onClick : (e, toastObject) => {
                          toastObject.goAway(0);
                      }
                  },
                  })  
                });
              }
              return false;
            }

            return true;
          }

          return false;

        } catch(e){
          console.log(e)
          return false
        }
      }
    }
  },
  computed: {
    canGoPrev(){
      return (this.currentVisible.index > 0)
    },
    canGoNext(){
      return (this.currentVisible.index < (this.tabList.length - 1))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

  @import url('@/less/global.less'); 
   .nav-tabs {
       a {
           color: #4a4a4a;
       }
       .active {
           color: @primary !important;
       }
   }

   .circle {
     background: #636161;
     border-radius: 15px;
     max-width: 30px;
     min-height: 30px;
     color: white;
     font-weight: 600;
   }

   .clickable {
     cursor: pointer
   }

   .circle.current-active {
      background: @primary;
    }

   .circle-text.current-active {
      color: @primary;
    }

   .title {
     font-weight: bold;
   }

   .tab-containers{
    //  background-color: #fafafa;
     padding: 40px;
   }

   .commands-palette{
     padding: 40px;
   }

  .custom-btn, .custom-btn:hover {
      padding: 10px;
      color:white;
      font-size: 16px;
      font-weight: bold;
      border: none;
      border-radius: 5px;
      a, a:hover {
        color: white !important;
        font-weight: bold;
        text-decoration: none;
      }
    }

    .custom-btn.next {
      background-color: @primary;
    }

    .custom-btn.prev {
      background-color: #656565;
    }

    .loadingClass {
      opacity: 0.6;
    }

    .blue {
      background-color: rgb(25, 130, 201);
    }
</style>
